export interface TabRailTabProps {
  /** Identifies this tab; matched against `TabRail`'s `activeTabId` and passed to `onSelectTab`. */
  value: string;
  /** The tab's label. Plain text only -- it doubles as the rename draft and the delete button's label. */
  children: string;
  /** When provided, a small "x" appears on hover/focus to remove this tab. */
  onDelete?: () => void;
  /**
   * When provided, double-clicking this tab's label enters inline rename mode. Enter/blur commits
   * the trimmed value; Escape cancels. Omit to leave this tab read-only.
   */
  onRename?: (label: string) => void;
}

// `TabRail.Tab` is a config-only descriptor, not a real rendered component -- `TabRail.List`
// reads these props directly off the element (via `Children.toArray`) before anything mounts, and
// renders the actual tab + its delete button itself. That's not a style choice: the delete button
// must be a DOM *sibling* of its tab sharing the same grid cell, never a descendant (see
// TabRailList.tsx) -- an ARIA constraint that a normal "each child renders its own subtree"
// component couldn't satisfy. This function body is never invoked by React; it exists only so
// `<TabRail.Tab>` type-checks and reads naturally as JSX.
export const TabRailTabPart = (_props: TabRailTabProps) => null;
